export const PREFIX_OPTIONS: {
    value: string;
    countryCode: string;
}[] = [
    {
        value: '420',
        countryCode: 'cz',
    },
    {
        value: '43',
        countryCode: 'at',
    },
    {
        value: '49',
        countryCode: 'de',
    },
    {
        value: '45',
        countryCode: 'dk',
    },
    {
        value: '34',
        countryCode: 'es',
    },
    {
        value: '33',
        countryCode: 'fr',
    },
    {
        value: '30',
        countryCode: 'gr',
    },
    {
        value: '36',
        countryCode: 'hu',
    },
    {
        value: '353',
        countryCode: 'ie',
    },
    {
        value: '39',
        countryCode: 'it',
    },
    { value: '212', countryCode: 'ma' },
    {
        value: '31',
        countryCode: 'nl',
    },
    {
        value: '47',
        countryCode: 'no',
    },
    { value: '968', countryCode: 'om' },
    {
        value: '48',
        countryCode: 'pl',
    },
    {
        value: '421',
        countryCode: 'sk',
    },
    {
        value: '385',
        countryCode: 'hr',
    },
    {
        value: '216',
        countryCode: 'tn',
    },
    {
        value: '90',
        countryCode: 'tr',
    },
    {
        value: '46',
        countryCode: 'se',
    },
    {
        value: '44',
        countryCode: 'uk',
    },
    {
        value: '370',
        countryCode: 'lt',
    },
    {
        value: '52',
        countryCode: 'mx',
    },
    {
        value: '63',
        countryCode: 'ph',
    },
    {
        value: '852',
        countryCode: 'hk',
    },
    {
        value: '351',
        countryCode: 'pt',
    },
    {
        value: '81',
        countryCode: 'jp',
    },
    {
        value: '41',
        countryCode: 'ch',
    },
    {
        value: '57',
        countryCode: 'co',
    },
    {
        value: '372',
        countryCode: 'ee',
    },
    {
        value: '40',
        countryCode: 'ro',
    },
    {
        value: '359',
        countryCode: 'bg',
    },
    {
        value: '381',
        countryCode: 'rs',
    },
    {
        value: '77',
        countryCode: 'kz',
    },
    {
        value: '380',
        countryCode: 'ua',
    },
    {
        value: '355',
        countryCode: 'al',
    },
    {
        value: '389',
        countryCode: 'mk',
    },
    {
        value: '84',
        countryCode: 'vn',
    },
];
